<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ name: 'Home' }">
        Mon compte
      </el-breadcrumb-item>

      <el-breadcrumb-item>
        Historique
      </el-breadcrumb-item>
    </el-breadcrumb>

    <template v-if="!!voyages">
      <el-alert
        v-if="voyages.length === 0"
        :closable="false"
        effect="dark"
        show-icon
        title="Aucun voyage"
        type="info"
      />

      <el-timeline v-else>
        <el-timeline-item
          v-for="voyage in voyages"
          :key="voyage.id"
          placement="top"
          :timestamp="voyage.date_depart | date "
        >
          <el-card
            :style="[voyage.statut.id === 'annule' ? { opacity: 0.5 } : {}]"
            shadow="never"
          >
            <template #header>
              <router-link
                class="vv-trip__title is-link"
                :to="{ name: 'Voyage', params: { id: voyage.id } }"
              >
                <nl2br
                  v-if="voyage.libelle_voyage"
                  tag="span"
                  :text="voyage.libelle_voyage.replace(/\\r\\n/g, '\n')"
                />
                <span v-else>
                  Votre voyage du {{ voyage.date_depart | date }} au {{ voyage.date_retour | date }}
                </span>
              </router-link>

              <div class="vv-trip__period">
                <template v-if="!!voyage.date_depart && !!voyage.date_retour">
                  du {{ voyage.date_depart | date }} au {{ voyage.date_retour | date }}
                </template>

                <template v-else-if="!!voyage.date_depart">
                  départ le {{ voyage.date_depart | date }}
                </template>

                <template v-else-if="!!voyage.date_retour">
                  retour le {{ voyage.date_retour | date }}
                </template>

                &nbsp;pour une durée de&nbsp;

                <template v-if="!!voyage.nombre_jours && !!voyage.nombre_nuits">
                  {{ voyage.nombre_jours }} jours / {{ voyage.nombre_nuits }} nuits
                </template>

                <template v-else-if="!!voyage.nombre_jours">
                  {{ voyage.nombre_jours }} jours
                </template>

                <template v-else-if="!!voyage.nombre_nuits">
                  {{ voyage.nombre_nuits }} nuits
                </template>
              </div>
            </template>

            <el-row
              :gutter="20"
              type="flex"
            >
              <el-col
                class="vv-trip-content"
                :xs="24"
                :lg="12"
              >
                <h4 class="vv-trip-content__title">
                  Mon voyage
                </h4>

                <el-alert
                  class="vv-trip-content__alert"
                  :closable="false"
                  effect="dark"
                  show-icon
                  :title="voyage.statut.name"
                  :type="voyage.statut.typeAlerte"
                />

                <p class="vv-trip-content__info">
                  <span>N° dossier&nbsp;:</span> {{ voyage.ref_dossier }}
                </p>

                <p class="vv-trip-content__info">
                  <span>Destination&nbsp;:</span> {{ voyage.destination }}
                </p>

                <p class="vv-trip-content__info">
                  <span>Ville de départ&nbsp;:</span> {{ voyage.ville_depart }}
                </p>

                <p
                  v-if="!!voyage.lieu_prise_en_charge && voyage.type !== 'prestation_agenceweb'"
                  class="vv-trip-content__info"
                >
                  <span>Lieu de prise en charge&nbsp;:</span>
                  <nl2br
                    tag="span"
                    :text="voyage.lieu_prise_en_charge.replace(/\\r\\n/g, '\n')"
                  />
                </p>

                <p class="vv-trip-content__info">
                  <span>Nombre de participant(s)&nbsp;:</span> {{ voyage.nb_personnes }} personne(s)
                </p>

                <p
                  v-if="!!voyage.organisateur"
                  class="vv-trip-content__info"
                >
                  <span>Organisateur&nbsp;:</span> {{ voyage.organisateur }}
                </p>
              </el-col>

              <el-col
                v-if="voyage.statut.id !== 'annule'"
                class="vv-trip-content"
                :xs="24"
                :lg="12"
              >
                <h4 class="vv-trip-content__title">
                  Paiement
                </h4>

                <el-alert
                  class="vv-trip-content__alert"
                  :closable="false"
                  effect="dark"
                  show-icon
                  :title="voyage.statut_paiement.name"
                  :type="voyage.statut_paiement.typeAlerte"
                />

                <p class="vv-trip-content__info">
                  <span>Montant du dossier&nbsp;:</span> {{ voyage.montant_total | currency }}
                </p>
              </el-col>
            </el-row>

            <template v-if="voyage.statut.id !== 'annule'">
              <el-divider />

              <el-row type="flex">
                <el-col
                  align="center"
                  :span="24"
                >
                  <el-button
                    size="medium"
                    type="info"
                    @click="$router.push({ name: 'Voyage', params: { id: voyage.id } })"
                  >
                    VOIR LE VOYAGE
                  </el-button>
                </el-col>
              </el-row>
            </template>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </template>
  </div>
</template>

<script>
// Librairies
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['voyages'])
  },

  created () {
    // Démarre l'indicateur de chargement
    this.$store.commit('startLoading')

    // Récupère les données utilisées par la vue
    Promise.all([
      this.$store.dispatch('getAgences'),
      this.$store.dispatch('getUserInfos'),
      this.$store.dispatch('getVoyages', { perPage: 100 })
    ])
      .finally(() => {
        // Stop l'indicateur de chargement
        this.$store.commit('stopLoading')
      })
  }
}
</script>
